import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { request } from "@/js/http/http_request";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import { getFullNameUser } from "@/js/user/user.js";
export default {
  name: "BankAccountComponent",
  data: function data() {
    return {
      errorMessage: null,
      elements: null,
      savePaymentForLater: false,
      bankAccountElement: null
    };
  },
  mounted: function mounted() {
    this.generateStripeFields();
  },
  components: {
    confirm: confirmationComponent
  },
  props: ["stripe", "value", "clientSecret", "wallet", "user", "order", "inboundDelivery"],
  methods: {
    saveBankAccount: function saveBankAccount() {
      var _this = this;
      return this.stripe.confirmSepaDebitSetup(this.clientSecret, {
        payment_method: {
          sepa_debit: this.bankAccountElement,
          billing_details: {
            name: getFullNameUser(this.user),
            email: this.user.login,
            address: {
              line1: this.user.billing_address.street,
              country: this.user.billing_address.country.iso_2
            }
          }
        }
      }).then(function (result) {
        var setupIntent = result.setupIntent;
        if (result.error) {
          _this.errorMessage = result.error.message;
          throw result.error.message;
        } else if (setupIntent.status === "requires_payment_method") {
          throw "Confirmation failed. Attempt again with a different payment method.";
        } else if (setupIntent.status === "succeeded") {
          if (_this.savePaymentForLater) {
            var data = {
              payment_method_id: result.setupIntent.payment_method
            };
            if (_this.order) {
              data = _objectSpread(_objectSpread({}, data), {}, {
                orderId: _this.order.id_order
              });
            } else if (_this.inboundDelivery) {
              data = _objectSpread(_objectSpread({}, data), {}, {
                inboundDeliveryId: _this.inboundDelivery.id
              });
            }
            request("/v1/stripe/payment-method", "post", data, true, "api").then(function () {
              _this.$emit("card-saved");
            });
          }
          return setupIntent.payment_method;
        }
      });
    },
    deleteBankAccount: function deleteBankAccount() {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this bank account ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          request("/v1/stripe/payment-method/" + _this.value.payment_method_id, "delete", null, true, "api").then(function () {
            _this.$emit("bank-deleted");
          });
        }
      });
    },
    generateStripeFields: function generateStripeFields() {
      if (this.stripe && !this.value) {
        this.elements = this.stripe.elements({
          locale: "en"
        });
        var options = {
          style: {
            base: {
              padding: "20rem",
              textAlign: "center",
              color: "#000",
              fontWeight: 500,
              fontSize: "16px",
              fontSmoothing: "antialiased",
              ":-webkit-autofill": {
                color: "#000"
              },
              "::placeholder": {
                color: "#CFD7DF"
              }
            },
            invalid: {
              color: "#FFC7EE",
              ":focus": {
                color: "#000"
              }
            }
          },
          supportedCountries: ["SEPA"]
        };
        this.bankAccountElement = this.elements.create("iban", options);
        this.bankAccountElement.mount("#bank-account-element");
        var _this = this;
        this.bankAccountElement.on("ready", function () {
          _this.bankAccountElement.focus();
        });
        this.bankAccountElement.on("change", function (e) {
          if (e.complete) {
            _this.$parent.$data.stripeErrorOccured = false;
            _this.$emit("input", 0);
            _this.$emit("confirm", true);
          }
          if (e.error) {
            _this.errorMessage = e.error.message;
            _this.$emit("confirm", false);
          } else {
            _this.errorMessage = null;
          }
        });
      }
    }
  },
  watch: {
    stripe: function stripe() {
      this.generateStripeFields();
    }
  }
};